import script from "./stxx.vue?vue&type=script&setup=true&lang=js"
export * from "./stxx.vue?vue&type=script&setup=true&lang=js"

import "./stxx.vue?vue&type=style&index=0&id=2f88c516&scoped=true&lang=css"

import exportComponent from "D:\\D盘\\桌面\\项目\\王者荣耀后台管理系统\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f88c516"]])

export default __exports__